module.exports = __webpack_public_path__ + "static/work-sans-v7-latin-600-9ce32c8432bac8f5d77131ccbd35c8f3.woff2";